"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _iframeResizerReact = _interopRequireDefault(require("iframe-resizer-react"));

var _cookieHelper = require("./cookieHelper");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ActionBarItem = _interopRequireDefault(require("@rio-cloud/rio-uikit/lib/es/ActionBarItem"));

var _CookieDisclaimer = require("./CookieDisclaimer");

var _IFrameDialog = require("./IFrameDialog");

var _IFramePopover = require("./IFramePopover");

var _lib = require("../../lib");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var USER_MENU_URL = 'https://user-menu.iam.rio.cloud';
var USER_MENU_LOCAL = 'http://localhost:3009';
var LOGOUT_URL = 'https://auth.iam.rio.cloud/logout';

var DefaultUserMenu = function DefaultUserMenu(_ref) {
  var disableCookieModal = _ref.disableCookieModal,
      environment = _ref.environment,
      localUserMenu = _ref.localUserMenu,
      locale = _ref.locale,
      logoutRedirectUri = _ref.logoutRedirectUri,
      preventLogoutRedirect = _ref.preventLogoutRedirect;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showDialog = _useState2[0],
      setShowDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      hidePopover = _useState6[0],
      setHidePopover = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      tabIndex = _useState8[0],
      setTabIndex = _useState8[1]; // the following variable is true when the consent cookies are not set
  // and false if they are set


  var _useState9 = (0, _react.useState)((0, _cookieHelper.getCookie)(_CookieDisclaimer.GA_CONSENT_COOKIE) === null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      enableCookieDisclaimer = _useState10[0],
      setEnableCookieDisclaimer = _useState10[1];

  var iFrameUrl = environment === 'production' ? USER_MENU_URL : localUserMenu ? USER_MENU_LOCAL : undefined;

  var popOver = /*#__PURE__*/_react.default.createRef();

  (0, _react.useEffect)(function () {
    if (hidePopover && popOver.current) {
      popOver.current.hide();
    }
  });

  var onIframeMessage = function onIframeMessage(event) {
    var messageOrigin = event.iframe.src.replace(/\/$/, ''); // remove trailing slash from src

    if (messageOrigin === iFrameUrl) {
      var message = event.message;

      switch (message.type) {
        case 'IFRAME_SHOW_DIALOG':
          setHidePopover(true);
          setShowDialog(true);
          setTabIndex(message.payload.selectedTab);
          break;

        case 'IFRAME_EXTERNAL_LOGIN_REDIRECT':
          window.location.href = message.payload;
          break;

        case 'IFRAME_LOGOUT':
          if (preventLogoutRedirect === true) {
            document.dispatchEvent(new CustomEvent(_lib.EVENT_USER_LOGGED_OUT));
          } else {
            window.location.href = logoutRedirectUri ? LOGOUT_URL + '?redirect_uri=' + logoutRedirectUri : LOGOUT_URL;
          }

          break;

        default:
          break;
      }
    }
  };

  var iframeResizerOptions = {
    log: false,
    minHeight: 50,
    checkOrigin: [iFrameUrl],
    onInit: function onInit() {
      setIsLoading(false);
    },
    onMessage: function onMessage(event) {
      return onIframeMessage(event);
    }
  };
  var userMenuPopover = iFrameUrl ? /*#__PURE__*/_react.default.createElement(_IFramePopover.IFramePopover, {
    iFrameUrl: iFrameUrl,
    isLoading: isLoading,
    iframeResizerOptions: iframeResizerOptions
  }) : /*#__PURE__*/_react.default.createElement(_iframeResizerReact.default, {
    id: 'mock-iframe',
    warningTimeout: 0,
    className: 'margin-top--10 margin-bottom--20',
    style: {
      width: '1px',
      minWidth: '100%',
      border: '0'
    },
    srcDoc: "<h4>Mocked User Menu</h4>"
  });

  var hideDialog = function hideDialog() {
    setShowDialog(false);
  };

  return /*#__PURE__*/_react.default.createElement(_ActionBarItem.default, {
    id: 'userMenu'
  }, /*#__PURE__*/_react.default.createElement(_ActionBarItem.default.Icon, null, /*#__PURE__*/_react.default.createElement("span", {
    className: 'icon rioglyph rioglyph-user',
    "data-cy": 'userMenu-icon'
  })), /*#__PURE__*/_react.default.createElement(_ActionBarItem.default.Popover, {
    useOffscreen: true
  }, userMenuPopover), disableCookieModal !== true && enableCookieDisclaimer && /*#__PURE__*/_react.default.createElement(_CookieDisclaimer.CookieDisclaimer, {
    environment: environment,
    locale: locale,
    setEnableCookieDisclaimer: setEnableCookieDisclaimer
  }), /*#__PURE__*/_react.default.createElement(_IFrameDialog.IFrameDialog, {
    show: showDialog,
    onClose: hideDialog,
    contentUrl: iFrameUrl,
    openTabIndex: tabIndex
  }));
};

var _default = DefaultUserMenu;
exports.default = _default;
DefaultUserMenu.propTypes = {
  disableCookieModal: _propTypes.default.bool,
  environment: _propTypes.default.string.isRequired,
  localUserMenu: _propTypes.default.bool,
  locale: _propTypes.default.string,
  logoutRedirectUri: _propTypes.default.string,
  preventLogoutRedirect: _propTypes.default.bool
};
DefaultUserMenu.defaultProps = {
  disableCookieModal: false,
  environment: 'production',
  localUserMenu: false,
  locale: 'en-GB'
};